import { UTM_PARAMETERS } from 'common/constants/utmParameters';

export const getUtmParams = (url) => {
  const { searchParams } = new URL(url);
  const result = {};

  for (const [key, value] of searchParams.entries()) {
    if (UTM_PARAMETERS.includes(key)) {
      result[key] = value;
    }
  }

  return result;
};
